export const codes = {
  BAD_REQUEST: "Bad Request",
  LICENSE_INVALID: "Invalid license",
  LICENSE_NOT_FOUND: "Store does not have any license yet",
  LICENSE_EXPIRED: "Subscription has expired"
}

export const errorCodes = {
  400: {
    icon: 'warning',
    title: "Failed",
    description: "Bad request!",
  },
  401: {
    icon: 'error',
    title: "Access Denied",
    description: 'Authentication failed',
  },
  403: {
    icon: 'error',
    title: "Access Denied",
    description: 'You are not allowed to access this resource',
  },
  404: {
    icon: 'warning',
    title: "Not Found",
    description: 'Not found',
  },
  405: {
    icon: 'warning',
    title: "Access Denied",
    description: 'Authentication failed',
  },
}



// WEBPACK FOOTER //
// ./src/interceptors/codes.js